import { useEffect, useState } from "react";
import { FileText, Upload, Trash2, AlertCircle } from "lucide-react";

import { SERVER_ORIGIN } from "../consts";
import { callApi, fileToBase64, fmtDate, formatDT } from "../utils";

export default function MaterialsTab({ group, practicals, getPracticals }) {
  const [num, setNum] = useState(practicals[0]?.number || 1);
  const [fileName, setFileName] = useState("");
  const [error, setError] = useState("");
  const [materialsLog, setMaterialsLog] = useState([]);

  const getMaterialsLog = () => {
    setMaterialsLog([]);

    callApi({
      method: "GET",
      path: `api/teacher/practice-groups/${group.id}/materials-log`,
      needAuth: true,
    }).then((response) => {
      const respErr = response.error;
      if (respErr) {
        console.error(respErr);
      } else {
        const respArr = response.response;
        if (respArr) {
          setMaterialsLog(respArr);
        } else {
          console.error(respArr);
        }
      }
    });
  };

  useEffect(() => {
    getMaterialsLog();
  }, [group.id]);

  const getNewData = () => {
    getPracticals();
    getMaterialsLog();
  };

  const handleFile = async (e) => {
    const f = e.target.files[0];
    setError("");

    if (!f) return;
    if (!f.name.toLowerCase().endsWith(".docx")) {
      setError("Методическое пособие должно быть в формате .docx.");
      return;
    }
    if (!f.name.startsWith(`Практика_${num}_`)) {
      setError(`Имя файла должно начинаться с «Практика_${num}_».`);
      return;
    }

    const base64String = await fileToBase64(f);

    const body = JSON.stringify({
      fileName: f.name,
      fileContent: base64String,
    });
    callApi({
      method: "POST",
      path: `api/teacher/practice-groups/${group.id}/materials/${num}`,
      body,
      needAuth: true,
    }).then((response) => {
      if (response.error) {
        setError(response.message ?? "При загрузке файла произошла ошибка");
      } else {
        setFileName(f.name);
        getNewData();
      }
    });
  };

  const removeMaterial = (n) => {
    callApi({
      method: "DELETE",
      path: `api/teacher/practice-groups/${group.id}/materials/${n}`,
      needAuth: true,
    }).then((response) => {
      if (response.error) {
        setError(response.message ?? "При удалении файла произошла ошибка");
      } else {
        setError("");
        getNewData();
      }
    });
  };

  return (
    <div className="cards">
      <div className="card materials-card">
        <h4>
          <FileText size={15} /> Методические материалы
        </h4>
        <table className="data-table">
          <thead>
            <tr>
              <th>Практика</th>
              <th>Файл</th>
              <th>Размещён</th>
              <th>Преподаватель</th>
            </tr>
          </thead>
          <tbody>
            {practicals.map((p) => {
              return (
                <tr key={p.number}>
                  <td className="num-cell">{p.number}</td>
                  <td>
                    {p.fileLink ? (
                      <>
                        <a
                          className="link"
                          href={`${SERVER_ORIGIN}${p.fileLink}`}
                        >
                          {p.fileName}
                        </a>
                        <button
                          className="icon-btn danger"
                          onClick={() => removeMaterial(p.number)}
                          aria-label="Удалить"
                        >
                          <Trash2 size={14} />
                        </button>
                      </>
                    ) : (
                      <span className="muted small">не размещено</span>
                    )}
                  </td>
                  <td>{fmtDate(p.publishedAt)}</td>
                  <td>{p.uploadedByName ?? "—"}</td>
                </tr>
              );
            })}
          </tbody>
        </table>

        <div className="upload-row">
          <select value={num} onChange={(e) => setNum(Number(e.target.value))}>
            {practicals.map((p) => (
              <option key={p.number} value={p.number}>
                Практика {p.number}
              </option>
            ))}
          </select>
          <label className="btn small">
            <Upload size={14} /> Загрузить .docx
            <input type="file" accept=".docx" hidden onChange={handleFile} />
          </label>
          {fileName && (
            <span className="muted small">Загружено: {fileName}</span>
          )}
        </div>

        {error && (
          <div className="error-box no-columns">
            <AlertCircle size={14} /> {error}
          </div>
        )}
      </div>

      <div className="card materials-log">
        <h4>Журнал изменений</h4>
        {materialsLog.length ? (
          <table className="data-table">
            <thead>
              <tr>
                <th>Событие</th>
                <th>Дата и время</th>
                <th>Преподаватель</th>
                <th>Номер практики</th>
                <th>Имя файла</th>
              </tr>
            </thead>
            <tbody>
              {materialsLog.map((entry) => (
                <tr key={entry.id}>
                  <td>{entry.eventLabel ?? "—"}</td>
                  <td>{formatDT(entry.at) ?? "—"}</td>
                  <td>{entry.teacherName ?? "—"}</td>
                  <td>{entry.practicalNumber ?? "—"}</td>
                  <td>{entry.fileName ?? "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p className="muted small">Изменений пока нет.</p>
        )}
      </div>
    </div>
  );
}
